/**
 * KDAlert — MUI Alert wrapper
 */

import { forwardRef } from "react";
import Alert from "@mui/material/Alert";

const KDAlert = forwardRef(({ color = "info", ...rest }, ref) => (
  <Alert
    ref={ref}
    severity={color}
    sx={{
      borderRadius: (theme) => theme.borders.borderRadius.md,
      ...rest.sx,
    }}
    {...rest}
  />
));

KDAlert.displayName = "KDAlert";

export default KDAlert;
